import React from 'react'
import GiftBoxDetailsComponent from '../../components/GiftBoxDetails'

export default function GiftBoxDetails () {
  return <><GiftBoxDetailsComponent/></>
}
